export default __webpack_public_path__ + "assets/images/6310b9b1de7460d3afa7a078f5d738d4.png";